export default __webpack_public_path__ + "static/media/Chestguard of the Defiant.8763c0bd.jpg";